import { TextField } from '@mui/material';
import PropTypes from 'prop-types';

import cm from '../../../utils/class-merge';

const Input = (props) => {
  // init
  const { placeHolder, error, helperText, className, label, ...rest } = props;

  return <TextField
    error={error}
    helperText={error ? helperText : undefined}
    className={cm('custom-form-input', className)}
    placeholder={placeHolder}
    label={label}
    {...rest}
  />;
};

Input.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  multiline: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  pattern: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  rows: PropTypes.number,
  placeHolder: PropTypes.string,
  className: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  label: PropTypes.string,
};

Input.defaultProps = {
  disabled: false,
};

export default Input;
